import { Box, Typography } from "@mui/material";

export interface OnboardingSummaryStat {
  label: string;
  testId: string;
  value: number;
}

export function OnboardingSummaryCards({ stats }: { stats: OnboardingSummaryStat[] }) {
  return (
    <Box
      sx={{
        display: "grid",
        gap: 2,
        gridTemplateColumns: { sm: "repeat(3, minmax(0, 1fr))", xs: "1fr" },
      }}
    >
      {stats.map((stat) => (
        <Box
          key={stat.testId}
          data-testid={stat.testId}
          sx={{
            bgcolor: "background.paper",
            border: 1,
            borderColor: "divider",
            borderRadius: 1,
            px: 2,
            py: 1.5,
          }}
        >
          <Typography color="text.secondary" variant="body2">
            {stat.label}
          </Typography>
          <Typography component="p" variant="h4">
            {stat.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
